import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '..';
import { IBaseResponse, IListItem, ISerologyTracking, ISerologySearchRequest, SerologyTrackingListType, ISerologyTrackingCounts } from '@nkr/models/index';
import { IGet, IPost } from "../authorization";

export enum SerologyListType {
    ToDo = 0,
    RequestsOfDonor = 10,
    RequestsOfRecipient = 20,
    Closed = 30
}

export interface ISerologyTrackingResponse {
    data: {
        success: boolean,
        message: string,
        results: ISerologyTracking
    }
}

export interface ISerologyTrackingListResponse {
    data: {
        success: boolean,
        message: string,
        results: ISerologyTracking[]
    }
}

export interface ISerologyLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            centerList: IListItem[]
        }
    }
}

export interface ISerologyTrackingCountsResponse {
    data: {
        success: boolean,
        results: ISerologyTrackingCounts
    }
}

export const ActionCreators = {
    getById: (serologyTrackingId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/get?serologyTrackingId=${serologyTrackingId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getByCenter: (centerId: number, serologyFilter: ISerologySearchRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingListResponse> => {
        let options: IPost = {
            url: `${__API__}/serology-tracking/${centerId}/by-center`,
            data: {
                CenterId: serologyFilter.centerId,
                DateStatus: serologyFilter.dateStatus,
                SerologyStatus: serologyFilter.serologyStatus,
                FilterStartDate: serologyFilter.filterStartDate,
                FilterEndDate: serologyFilter.filterEndDate
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    markReceived: (id: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/mark-received?centerId=${centerId}`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    markShippedOut: (id: number, centerId: number, trackingNumber: string, shippedDateTime: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/mark-shipped-out?centerId=${centerId}`,
            data: {
                trackingNumber,
                shippedDateTime
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    markRemoteShipped: (id: number, centerId: number, trackingNumber: string, shippedDateTime: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/mark-remote-shipped?centerId=${centerId}`,
            data: {
                trackingNumber,
                shippedDateTime
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    markShippedBack: (id: number, centerId: number, trackingNumber: string, shippedDateTime: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/mark-shipped-back?centerId=${centerId}`,
            data: {
                trackingNumber,
                shippedDateTime
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    markCancelled: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/mark-cancelled`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    markResultsSent: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/mark-results-sent`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    updateDeadline: (id: number, deadline: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/${id}/deadline?deadline=${deadline}`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getSerologyLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyLookupDataResponse> => {
        let options = {
            url: `${__API__}/serology-tracking/lookup-data`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getByListType: (listType: SerologyTrackingListType) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingListResponse> => {
        let options: IGet = {
            url: `${__API__}/admin/serology-tracking/by-list-type?listType=${listType}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getCounts: () => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTrackingCountsResponse> => {
        let options: IGet = {
            url: `${__API__}/admin/serology-tracking/counts`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    deleteSerologyTracking: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IGet = {
            url: `${__API__}/admin/serology-tracking/${id}/delete`
        };

        return await dispatch(AuthActionCreators.apiDelete(options));
    }
};
